import { type QueryResult, useQuery } from "@apollo/client";

import { type Maybe, type QrCode } from "../../gql-generated/types";
import { getLensQrCode } from "../api/queries/getLensQrCode";
import { type GetLensQrCodeQuery, type GetLensQrCodeQueryVariables } from "../api/queries/getLensQrCode.gql-generated";

export const useLensQrCode = (
    lensId: string | undefined,
    enabled: boolean,
): Pick<QueryResult<GetLensQrCodeQuery, GetLensQrCodeQueryVariables>, "loading" | "error" | "refetch"> & {
    qrCode: Maybe<QrCode> | undefined;
} => {
    const { data, loading, error, refetch } = useQuery<GetLensQrCodeQuery, GetLensQrCodeQueryVariables>(getLensQrCode, {
        variables: { lensId: lensId ?? "" },
        skip: !lensId || !enabled,
        notifyOnNetworkStatusChange: true,
    });

    return { qrCode: data?.getLens.lens?.qrCode, loading, error, refetch };
};
